import { TAutocompleteOption } from '~/components/AutocompleteField/types';

export enum TCounterpartySelectorMode {
  Client = 'client',
  Operator = 'operator',
  CovenantsBranchManager = 'covenants_branch_manager',
  UakdoAdministrator = 'uakdo_administrator',
  EmailBlacklist = 'email_blacklist',
}

export type TIdentitySource = string | number | Record<string, unknown> | null | undefined;

export type TCounterpartySearchCachePayload = {
  code: string;
  lastLoginAt: string;
};

export type TCounterpartyAutocompleteOption = TAutocompleteOption & {
  lastLoginAt?: string;
};

export type TCounterpartySearchFieldValue = TCounterpartyAutocompleteOption | string | null;

export type TAccessTokenPayload = {
  sub?: string;
  preferred_username?: string;
  username?: string;
  login?: string;
  email?: string;
  user_name?: string;
  userId?: string | number;
  uid?: string | number;
};
